// extracted by mini-css-extract-plugin
export var active = "_cv-7";
export var container = "_cv-0";
export var evenWidth = "_cv-4";
export var large = "_cv-5";
export var outlet = "_cv-8";
export var slide = "_cv-2";
export var small = "_cv-6";
export var tab = "_cv-3";
export var tabs = "_cv-1";